import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import '../../node_modules/slick-carousel/slick/slick-theme.css'
import '../../node_modules/slick-carousel/slick/slick.css'

@Component({
    components: AllComponents(),
})
export default class Top extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";
    
    private bannerList: {id: number, img: string, url?: string}[] = [];
    public slickOptions = {
        slidesToShow: 1,
        centerPadding: '0',
        centerMode: true,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        autoplaySpeed: 5000,
        dots: false,
        arrows: true,
        prevArrow:'<button type="button" class="slick-prev"></button>',
        nextArrow:'<button type="button" class="slick-next"></button>' 
    }

    public saleProduct: BASEAPI.Product[] = [];
    public endProduct: BASEAPI.Product[] = [];

    public nowDate: Date  = new Date();

    public async created() {
        await this.init();
    }

    @Watch('$route')
    public async init() {

        // 開催予定＋開催中
        let saleRes = await BASEAPI.ProductController.getProductListUsingGET(undefined, "SALE").catch(AxiosErrorHandler);
        if (!isAxiosError(saleRes)) {
            this.saleProduct = saleRes.data;
            this.bannerList = [];
            this.saleProduct.forEach((product, index) => {
                this.bannerList.push({
                    id: index,
                    img: product.image,
                    url: "/product/" + product.directoryName
                })
            })
            if(this.bannerList.length === 1){
                this.bannerList.push({id: 1, img: this.bannerList[0].img, url: this.bannerList[0].url})
            }
        }

        if(this.bannerList.length === 0){
            this.bannerList.push({id: 1, img: "https://cdn.oshi-challe.jp/images/bnr_top01.jpg"},{id: 2, img: "https://cdn.oshi-challe.jp/images/bnr_top02.jpg"},)
        }

        // 開催終了
        let endRes = await BASEAPI.ProductController.getProductListUsingGET(6, "END").catch(AxiosErrorHandler);
        if (!isAxiosError(endRes)) {
            this.endProduct = endRes.data;
        }


        this.nowDate = new Date(saleRes.headers.date);

        setTimeout(() => {
            const el = document.getElementById('tweetScript');
            const swiperEl = document.getElementById('swiperEl');
            if(el) el.remove();
            if(swiperEl) swiperEl.remove();
            
            let tweetScript = document.createElement('script')
            tweetScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
            tweetScript.setAttribute('async', 'true')
            tweetScript.id = 'tweetScript';
            document.head.appendChild(tweetScript);

            let styleSheet = document.createElement('style')
            styleSheet.innerText = 
            ".slick-prev{top: calc(50% - 36px);left: 25px;right: auto;width: 50px;height: 50px;margin: 0;border-left: 12px solid #7fccdc;border-bottom: 12px solid #7fccdc;transform: rotate(45deg);z-index: 1;}" +
            ".slick-next{top: calc(50% - 36px);left: auto;right: 25px;width: 50px;height: 50px;margin: 0;border-top: 12px solid #7fccdc;border-right: 12px solid #7fccdc;transform: rotate(45deg);z-index: 1;}" +
            ".slick-prev:before, .slick-next:before{display: none;}" +
            ".slick-list{overflow: visible;}" +
            "@media only screen and (max-width:767px) {" +
            ".slick-prev{top: calc(50% - 15px);left: 15px;width: 20px;height: 20px;border-left: 6px solid #7fccdc;border-bottom: 6px solid #7fccdc;}" +
            ".slick-next{top: calc(50% - 15px);right: 15px;width: 20px;height: 20px;border-top: 6px solid #7fccdc;border-right: 6px solid #7fccdc;}" +
            "}";
            styleSheet.id = 'swiperEl';
            document.head.appendChild(styleSheet);
        }, 500)
    }


    public getDayOfWeek(date: string){
        let yearStr: number = Number(date.substring(0, date.indexOf('年')));
        let monthStr: number = Number(date.substring(date.indexOf('年') + 1, date.indexOf('月')));
        let dayStr: number = Number(date.substring(date.indexOf('月') + 1, date.indexOf('日')));
        const dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ] ;
        let newDate = new Date( yearStr, monthStr - 1 , dayStr);
        return(dayOfWeekStrJP[newDate.getDay()]);
    }

    public checkSales(date: Date){
        if(new Date(date) > this.nowDate!){
            return false
        } else {
            return true;
        }
    }

    public getImgList(product: BASEAPI.Product){
        let allImgList: {img: string, title: string}[] = [];
        let imgList: {img: string, title: string}[] = [];
        product.productPrizeGroupList?.forEach(productPrizeGroup => {
            productPrizeGroup.prizeList?.forEach(prize => {
                allImgList.push({img: prize.image, title: prize.title});
            })
        })

        if(allImgList.length < 4){
            return [];
        }

        for(let i = 0; i < 4; i++){
            let rndInt = Math.floor(Math.random() * allImgList.length);
            imgList.push(allImgList[rndInt]);
            allImgList.splice(rndInt,1)
        }

        return imgList;
    }

}
